import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { docEntityIsHidden } from "./entity/docEntityHidable";
import { docForeignHashTableApplyOp } from "./entity/docForeignHashTableOps";
import { entitySetNew } from "./entity/entitySet";

/**
 * Get the hidden state of a group based on its children's states
 */
export function getGroupHiddenState(doc: Doc, childHandles: DocEntityHandle[]): boolean {
  return childHandles.every((handle) => docEntityIsHidden(doc, handle));
}

/**
 * Update the hidden state of a group in the doc
 */
export function updateGroupHidden(doc: Doc, parentHandle: DocEntityHandle, allHidden: boolean): Doc {
  if (docEntityIsHidden(doc, parentHandle) !== allHidden) {
    return {
      ...doc,
      hidden: docForeignHashTableApplyOp(doc.hidden, entitySetNew([parentHandle]), "XOR"),
    };
  }
  return doc;
}
